import { instance } from "./axios";
import { ApiInterface } from "../interfaces/api.interface";
import { ENV } from "../config/env";
import getApiVariable from "../utils/get-api-variable";

export default {
  call: ({
    data,
    url,
    action,
    requiresToken,
    query,
    extraData,
    refine,
    type,
  }: ApiInterface) =>
    instance({
      method: "POST",
      url: url,
      data: {
        variables: getApiVariable(action, data, refine, extraData, type),
        query,
      },
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "x-api-key": ENV.apiKey,
        requiresToken,
      },
    }),
};
